import React from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../context/LanguageContext';
import { profile } from '../data/mock';
import { Mail, Linkedin, MapPin } from 'lucide-react';

const Footer = () => {
  const { t, language } = useLanguage();
  const year = new Date().getFullYear();

  return (
    <footer className="border-t border-white/10 sky-section-soft mt-16">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 lg:px-12 py-12">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10">
          {/* Brand */}
          <div className="md:col-span-5">
            <div className="flex items-center gap-2.5 mb-3">
              <div className="w-9 h-8 rounded-md bg-[#4A8FD1] text-slate-50 flex items-center justify-center font-bold text-xs mono tracking-wider px-1">
                SVM
              </div>
              <span className="font-semibold text-slate-50">{profile.name}</span>
            </div>
            <p className="text-sm text-slate-400 max-w-sm leading-relaxed">
              {t('footer.tagline')}
            </p>
            <div className="mt-4 flex items-center gap-2 text-xs text-slate-500 mono">
              <MapPin className="w-3.5 h-3.5" />
              <span>{profile.location[language]}</span>
            </div>
          </div>

          {/* Nav */}
          <div className="md:col-span-3">
            <h4 className="text-xs font-semibold uppercase tracking-widest text-slate-50 mb-4 mono">
              {t('footer.nav')}
            </h4>
            <ul className="space-y-2 text-sm">
              <li><Link to="/" className="text-slate-400 hover:text-[#4A8FD1] link-underline">{t('nav.home')}</Link></li>
              <li><Link to="/projects" className="text-slate-400 hover:text-[#4A8FD1] link-underline">{t('nav.projects')}</Link></li>
              <li><Link to="/skills" className="text-slate-400 hover:text-[#4A8FD1] link-underline">{t('nav.skills')}</Link></li>
              <li><Link to="/about" className="text-slate-400 hover:text-[#4A8FD1] link-underline">{t('nav.about')}</Link></li>
              <li><Link to="/contact" className="text-slate-400 hover:text-[#4A8FD1] link-underline">{t('nav.contact')}</Link></li>
            </ul>
          </div>

          {/* Connect */}
          <div className="md:col-span-4">
            <h4 className="text-xs font-semibold uppercase tracking-widest text-slate-50 mb-4 mono">
              {t('footer.connect')}
            </h4>
            <ul className="space-y-2.5 text-sm">
              <li>
                <a
                  href={`mailto:${profile.email}`}
                  className="flex items-center gap-2 text-slate-300 hover:text-[#4A8FD1]"
                >
                  <Mail className="w-4 h-4" />
                  <span className="mono text-xs">{profile.email}</span>
                </a>
              </li>
              <li>
                <a
                  href={profile.linkedin}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex items-center gap-2 text-slate-300 hover:text-[#4A8FD1]"
                >
                  <Linkedin className="w-4 h-4" />
                  <span className="mono text-xs">linkedin.com/in/sagarvm</span>
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-white/10 flex flex-col sm:flex-row justify-between items-start sm:items-center gap-3 text-xs text-slate-500 mono">
          <span>© {year} {profile.name}. {t('footer.rights')}</span>
          <span className="flex items-center gap-1.5">
            <span className="text-slate-500">{t('footer.developedBy')}</span>
            <a
              href="https://innectsphere.ca"
              target="_blank"
              rel="noopener noreferrer"
              data-testid="footer-innectsphere-link"
              className="text-[#4A8FD1] hover:text-[#6AAFE0] font-semibold tracking-wide"
            >
              InnectSphere Ltd.
            </a>
          </span>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
